module.exports = __webpack_public_path__ + "static/media/formHtml.670e3a3c.png";